module.exports = __webpack_public_path__ + "static/media/tron_3.2aa1c69b.gif";